
type Props = {
  isVisible: boolean;
  logo: string;
};


function SplashScreen({ isVisible, logo }: Props) {
  if (!isVisible) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "#0f0f0f",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999
      }}
    >
      <img
        src={logo}
        alt="Loading"
        className="pulse-logo"
        style={{ width: "450px", height: "450px" }}
      />
    </div>
  );
}


export default SplashScreen;